var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "context-menu-container",
      style: _vm.style,
      attrs: { tabindex: "0" },
      on: {
        blur: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }